<div class="container-fluid full-page-height">
    <div class="row">
        <div class="col-12">
            <h5 class="cursor d-flex align-items-center mb-0">
                <u routerLink="#" (click)="finish()">{{'Home' | translate}}</u>
            </h5>

            <h2 class="d-flex mb-16 align-items-center mt-0">
                <mat-icon matTooltip="{{'ToMainViewBulkActivationTooltip'|translate}}" routerLink="#" (click)="finish()"
                    class="arrow-icon-left cursor" svgIcon="Back"></mat-icon>

                <span class="facility">{{'BulkActivationRegistration'|translate}}</span>
            </h2>
        </div>
    </div>
    <span style="position: absolute; visibility: hidden;font-family: 'OpenSans-Bold'; font-size: 29pt;">preload</span>
    <dhhp-card class="common-card-container mb-2 p-3">
        <div class="table-responsive table-class">
            <mat-table class="border" [dataSource]="pagedData" [trackBy]="trackByIndex">
                <ng-container matColumnDef="serialNumber">
                    <mat-header-cell *matHeaderCellDef>
                        {{ "SerialNumber" | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input type="text" [value]="element.serialNumber" disabled />
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="activationCode">
                    <mat-header-cell *matHeaderCellDef>
                        {{ "ActivationCode" | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <input type="text" [value]="formatActivationCode(element.activationCode)" disabled />
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </div>
        <dhhp-card class="border" *ngIf="!isDataAvailable">
            <p class="text-center norecords">{{ "NoDataUploaded" | translate }}</p>
        </dhhp-card>
        <mat-paginator [length]="data.length" [pageSize]="10" [pageSizeOptions]="[10, 20, 30]"
            (page)="onPageChange($event)">
        </mat-paginator>
    </dhhp-card>
</div>
<div class="action-buttons">
    <button mat-raised-button color="primary" matTooltip="{{'DownloadBulkLabels'|translate}}" (click)="download()"
        [disabled]="isButtonsDisabled">{{'DownloadBulkLabels'|translate}}</button>
    <button mat-raised-button color="primary" matTooltip="{{'PrintBulkLabels'|translate}}" (click)="print()"
        [disabled]="isButtonsDisabled">{{'PrintBulkLabels'|translate}}</button>
    <button mat-raised-button color="primary" matTooltip="{{'Finish'|translate}}"
        (click)="finish()">{{'Finish'|translate}}</button>
</div>